import AgentsShow from "./Show"

export default function AgentsEdit(props) {
  return <AgentsShow {...props} mode="edit" />
}
